import { AfterViewInit, Component, ContentChildren, OnInit, QueryList, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalsHandlerService } from '../modals.handler.service';
import { TranslatorService } from './../../../shared/services/utils/translator.service';

@Component({
  selector: 'ngx-email-modal',
  templateUrl: './email-modal.component.html',
})
export class EmailModalComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;
  @ContentChildren('a', { descendants: true }) links: QueryList<any>;
  loadingData = true;
  emailHtml: string;
  title = this.translator.trans('pages.leads.email');
  constructor(
    private readonly modalService: NgbModal,
    private readonly modalsHandler: ModalsHandlerService,
    private readonly translator: TranslatorService
  ) { }
  ngAfterViewInit(): void {
    this.modalsHandler.emailModal.subscribe(mail => {
      this.emailHtml = mail;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false,
        }).result.finally(() => {
          this.emailHtml = '';
        });
    });
  }

  ngOnInit(): void {
  }
}
